import React from 'react'

function ProductDescriptionComponent({ product, getProductTranslations }) {
    return (
        <div className="descr-wrap">
            <div
                className="descr"
                dangerouslySetInnerHTML={{ __html: getProductTranslations(product)?.productDescription }}
            ></div>
        </div>
    )
}
export default ProductDescriptionComponent